<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--onboarding">
    <main class="l-main">
      <div class="p-onboarding-welcome">
        <div class="p-onboarding-welcome-inner">
          <div class="p-onboarding-welcome__content">
            <h1 class="c-title">
              <div class="c-title__text c-title__text--blue u-fs46">PUSH ONEへようこそ！</div>
            </h1>
            <div class="c-text u-w580" style="font-size: 17px;">PUSH ONEではサイトへアクセスしたユーザーへプッシュ通知を使った情報配信が行えます。アプリをお持ちでない方でもWebサイトさえあれば、ユーザーへアプリ同様のプッシュ通知が行なえる新しいコミュニケーション・集客ツールです。</div>
          </div>
          <div class="c-image">
            <img src="/assets/img/sketch-onboarding-01.svg" />
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-onboarding-howto">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">さぁ、はじめましょう！</div>
            <div class="c-text u-fs--l">初期設定を行い、プッシュ通知の配信をスタートしよう。</div>
          </h2>
          <ul class="p-onboarding-howto-list">
            <li class="p-onboarding-howto-list__item">
              <div class="p-onboarding-howto__title">STEP.1</div>
              <h3 class="c-title">
                <div class="c-title__text u-fs24">導入準備</div>
              </h3>
              <div class="c-image u-w198"><img src="/assets/img/logo-firebase--standard.svg" /></div>
              <div class="p-onboarding-howto__text">
                メッセージ配信時に経由するGoogle社が提供するFirebaseから設定情報を取得します。</div>
            </li>
            <li class="p-onboarding-howto-list__item">
              <div class="p-onboarding-howto__title">STEP.2</div>
              <h3 class="c-title">
                <div class="c-title__text u-fs24">プロジェクト作成</div>
              </h3>
              <div class="c-image u-w150"><img src="/assets/img/sketch-onboarding-02.svg" /></div>
              <div class="p-onboarding-howto__text">
                プッシュ通知を行うWebサイト（ドメイン）の設定を行いプロジェクトを作成致します。</div>
            </li>
            <li class="p-onboarding-howto-list__item">
              <div class="p-onboarding-howto__title">STEP.3</div>
              <h3 class="c-title">
                <div class="c-title__text u-fs24">Webサイトでの設定</div>
              </h3>
              <div class="c-image u-w130"><img src="/assets/img/sketch-onboarding-03.svg" /></div>
              <div class="p-onboarding-howto__text">
                Webサイトでタグの設置とファイルのアップロードを行うことで、サイトへアクセスしたユーザーへオプトイン（通知許可）ダイアログの表示が開始されます。</div>
            </li>
          </ul>


          <button
            class="c-btn c-btn--blue u-w360 u-h48 u-fs18"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">初期設定をスタートする</p>
          </button>


        </div>
      </div>
    </main>
  </div>
<!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    linkUrl: String,
  },
  methods: {
    onNextClick: function (_event) {
      location.href = this.linkUrl;
    },
  },
}
</script>
